// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__wSfRK","jpCurrentDate":"JP_Footer_jpCurrentDate__eF+uM","jpFootage":"JP_Footer_jpFootage__Ht-3N","higlight":"JP_Footer_higlight__Y0NN6"};